const PREFIX = 'courses';
export const GET_ENROLLMENT = PREFIX + ':get:enrollment';
export const DELETE_ENROLLMENT = PREFIX + ':delete:enrollment';
export const GET_SECTIONS = PREFIX + ':get:sections';
export const COMBINED_SECTIONS = PREFIX + ':combined:sections';
export const COMBINED_USERS = PREFIX + ':combined:users';
export const ADD_SECTIONS = PREFIX + ':add:sections';
export const GET_COURSE_USERS = PREFIX + ':get:users';

export const  getEnrollment = (courseId, token) => {
    return{
        type: GET_ENROLLMENT,
        courseId,
        token
    }
}

export const  deleteEnrollment = (id, courseId, token) => {
    return{
        type: DELETE_ENROLLMENT,
        id,
        courseId,
        token
    }
}

export const  getSections = (courseId, token) => {
    return{
        type: GET_SECTIONS,
        courseId,
        token
    }
} 

export const  addSections = (name, id , token) => {
    const data = {
        "course_section[name]": name
    }

    return {
        type: ADD_SECTIONS,
        data, 
        id,
        token
    }
}

export const  getCourseUsers = (id, token, newUrl = false, searchFilter = false) => {
    return{
        type: GET_COURSE_USERS,
        id,
        newUrl,
        searchFilter,
        token
    }
}